import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import {
  getIncidentInstructions,
  updatePromptInstructions, 
  updateSummaryInstructions, 
} from "actions";
import { set } from "lodash";

const AIPrompt = () => {
  const dispatch = useDispatch();
  const incidentState = useSelector((state) => state.incidentState);


  const [promptInstructions, setPromptInstructions] = useState("");
  const [summaryInstructions, setSummaryInstructions] = useState("");
  const [promptId, setPromptId] = useState(null);

  // Fetch instructions
  useEffect(() => {
    dispatch(getIncidentInstructions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Populate from incidentState when it updates
  useEffect(() => {
    if (incidentState && incidentState.incidentInstructionsList) {
      const record = incidentState.incidentInstructionsList;
    
      setPromptInstructions(record.prompt_instructions || "");
      setSummaryInstructions(record.summary_instructions || "");
      setPromptId(record.id || null);
    }
  }, [incidentState]);

  // Separate onChange handlers
  const handlePromptChange = (e) => setPromptInstructions(e.target.value);
  const handleSummaryChange = (e) => setSummaryInstructions(e.target.value);

  // Separate update handlers
  const handlePromptUpdate = () => {
    dispatch(
      updatePromptInstructions(
        { prompt_instructions: promptInstructions }, // match DB column
        promptId
      )
    ).then(() => {
      // once update succeeds, fetch fresh data
      dispatch(getIncidentInstructions());
    });
  };

  const handleSummaryUpdate = () => {
    dispatch(
      updateSummaryInstructions(
        { summary_instructions: summaryInstructions }, // match DB column
        promptId
      )
    ).then(() => {
      // once update succeeds, fetch fresh data
      dispatch(getIncidentInstructions());
    });
  };

  return (
    <div className="p-4">
      <div className="main-content-div">
        <h4 className="font-20 font-weight-bold heading-color mb-3">
          AI Prompt Instructions
        </h4>

        <Form>
          {/* Prompt Instruction */}
          <Form.Group className="mb-3" controlId="promptInstruction">
            <Form.Label className="input-label">
              Root Cause Analysis/Questions Prompt
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              style={{
                color: "#8A9193",
                backgroundColor: "#ffffff",
                border: "1px solid #DFE4E2",
                borderRadius: "8px",
                padding: "10px",
                fontSize: "13px",
                outline: "none",
              }}
              placeholder="Instruction"
              value={promptInstructions}
              name="prompt_instructions"
              onChange={handlePromptChange}
            />
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="mt-3 save-btn"
                onClick={handlePromptUpdate}
              >
                Update
              </button>
            </div>
          </Form.Group>

          {/* Summary Instruction */}
          <Form.Group className="mb-3" controlId="summaryInstruction">
            <Form.Label>Root Cause Summary Prompt</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              style={{
                color: "#8A9193",
                backgroundColor: "#ffffff",
                border: "1px solid #DFE4E2",
                borderRadius: "8px",
                padding: "10px",
                fontSize: "13px",
                outline: "none",
              }}
              placeholder="Summary Instruction"
              value={summaryInstructions}
              name="summary_instructions"
              onChange={handleSummaryChange}
            />
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="mt-3 save-btn"
                onClick={handleSummaryUpdate}
              >
                Update
              </button>
            </div>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};

export default AIPrompt;
